import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
	root: {
		minWidth: 300,
	},
	shadowDown: {
		boxShadow: `0 2px 3px 1px ${theme.palette.custom.shadow.grey}`,
	},
	shadowUpAndDown: {
		boxShadow: `0 2px 3px 1px ${theme.palette.custom.shadow.grey}, 0 -2px 3px 1px ${theme.palette.custom.shadow.grey}`,
	},
	shadowUp: {
		boxShadow: `0 -2px 3px 1px ${theme.palette.custom.shadow.grey}`,
	},
	nested: {
		paddingLeft: theme.spacing(4),
	},
	badge: {
		...theme.palette.custom.badge,
	},
	menuIcon: {
		color: theme.palette.text.primary,
	},
	listItemSecondaryAction: {
		right: 20,
	},
	listItemIcon: {
		color: theme.palette.text.primary,
	},
}));
